/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Home from './components/Home/Home'; // Assuming you have a Home component
// Component imports
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Services from "./components/Services/Services";
import CarList from "./components/CarList/CarList";
import AppStoreBanner from "./components/AppStoreBanner/AppStoreBanner";
import Contact from "./components/Contact/Contact";
import Testimonial from "./components/Testimonial/Testimonial";
import Footer from "./components/Footer/Footer";
import Cart from "./components/Cart/Cart";
import Cars from "./components/cars/cars";
import Checkout from "./components/Cart/checkout";
import SignIn from "./components/Auth/SignIn";
import Register from "./components/Auth/Register";
import VerifyCode from "./components/Auth/verifycode";
import { calculateTotalCount } from './components/Utility/calculateTotalCount'; // Import the utility function
import UserProfile from "./components/Auth/profile";
import { getUser } from "./components/Utility/getUser";
import Dashboard from "./components/Auth/Dashboard";
import MyFavorite from "./components/MyFavorite/myFavorite";

const App = () => {
  // dark mode start
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );
  const element = document.documentElement;

  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = async () => {
    try {
      const user = getUser(); // Get the user information from local storage

      const response = await fetch(`https://panel.masit.net/api/view.php?table=cartview&cart_usersid=${user.users_id}`); // Replace with your API endpoint
      const data = await response.json();
      const totalCount = calculateTotalCount(data); // Use the utility function
      setCartCount(totalCount);
    } catch (error) {
      //console.error('Error fetching cart data:', error);
    }
  };

  useEffect(() => {
    if (theme === "dark") {
      element.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      element.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
    fetchCartCount();
  }, [element.classList, theme]);

  // dark mode end

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 800,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
    fetchCartCount();
  }, []);

  return (
    <>
      <div className="bg-white dark:bg-black dark:text-white text-black overflow-x-hidden">
        <Navbar theme={theme} setTheme={setTheme} cartCount={cartCount} fetchCartCount={fetchCartCount} />
        <Routes>
          <Route path="/" element={<>
            <Hero theme={theme} />
            <About />
            <Services />
            <CarList theme={theme} />
            <Testimonial />
            <AppStoreBanner />
            <Contact />
            <Footer />
          </>} />
          <Route path="/MyFavorite" element={<MyFavorite />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/register" element={<Register />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/cart" element={<Cart fetchCartCount={fetchCartCount} />} />
          <Route path="/ProductDetail/:id" element={<ProductDetail fetchCartCount={fetchCartCount} />} />
          <Route path="/cars" element={<Cars />} />
          <Route path="/verifycode" element={<VerifyCode />} />
        </Routes>
      </div>
    </>
  );
};

export default App;
